<template>
	<div class="spinner">
		<img
			src="@/assets/img/loading.gif"
			alt="Loading..."
		/>
	</div>
</template>

<script>
export default {
	name: 'Loader'
}
</script>

<style scoped lang="scss">
@import "src/scss/toolkit";

.spinner {
	padding: rem(32) 0;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/Loader.vue